<template>
  <div style="margin: 1em 0;">
    <span v-if="totalRecords > 0" style="display: inline-block; position: relative; top: -0.75em;">
      <span v-if="isLoading">Chargement:</span>
      <span v-else>Affiche:</span>
      {{ showingFrom }} à {{ showingTo }} de {{ totalRecords }}
    </span>
    <select class="form-control" v-model="selfPageSize" style="max-width: 10em; display: inline; margin: 0 0 0 1em; position: relative; top: -0.75em;">
      <option v-for="option in sizeOptions" :value="option" :key="option">{{ option }} par page</option>
    </select>
    <nav aria-label="Pagination" v-show="numPages > 1" style="display: inline-block; margin-left: 2em;">
      <ul class="pagination" style="margin: 0;">
        <li :class="{ 'disabled': isFirstPageSelected || disable }">
          <span v-if="isFirstPageSelected || disable">
            <span aria-hidden="true">&laquo;</span>
          </span>
          <a v-else href="#" aria-label="Page Précédente" @click="prevPage">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li v-for="n in pageRange" :key="n" :class="{ 'active': isActive(n), 'disabled': isEllipsis(n) }">
          <span v-if="isEllipsis(n)" aria-hidden="true" v-text="n" />
          <template v-else>
            <span v-if="isActive(n)">
              {{ n }} <span class="sr-only">(current)</span>
            </span>
            <a v-else href="#" v-text="n" @click="changePage(n, $event)" :class="{ 'disabled': disable }"></a>
          </template>
        </li>
        <li :class="{ 'disabled': isLastPageSelected || disable }">
          <span v-if="isLastPageSelected || disable">
            <span aria-hidden="true">&raquo;</span>
          </span>
          <a v-else href="#" aria-label="Prochaine Page" @click="nextPage">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: ['selectedPageNum', 'pageSize', 'totalRecords', 'isLoading', 'disable', 'limit', 'sizeOptions'],
  data: function() {
    return {
      selfPageSize: null
    }
  },
  computed:
  {
    numPages: function() {
      var result = Math.ceil(this.totalRecords / this.pageSize)
      return result < 1 ? 1 : result
    },
    isFirstPageSelected: function() {
      return this.selectedPageNum === 1
    },
    isLastPageSelected: function() {
      return this.selectedPageNum === this.numPages
    },
    pageRange: function() {
      // see https://github.com/gilbitron/laravel-vue-pagination/blob/master/src/RenderlessLaravelVuePagination.vue

      var current = this.selectedPageNum;
      var last = this.numPages;
      var delta = this.limit;
      var left = current - delta;
      var right = current + delta + 1;
      var range = [];
      var pages = [];
      var l;

      if (this.limit === undefined) { // show all
        left = 1;
        right = last;
      }

      for (var i = 1; i <= last; i++) {
          if (i === 1 || i === last || (i >= left && i < right)) {
              range.push(i);
          }
      }
      range.forEach(function (i) {
          if (l) {
              if (i - l === 2) {
                  pages.push(l + 1);
              } else if (i - l !== 1) {
                  pages.push('...');
              }
          }
          pages.push(i);
          l = i;
      });
      return pages;
    },
    showingFrom() {
      return ((this.selectedPageNum - 1) * this.pageSize) + 1
    },
    showingTo() {
      if (this.totalRecords < this.selectedPageNum * this.pageSize) {
        return this.totalRecords
      }
      return this.selectedPageNum * this.pageSize
    }
  },
  methods:
  {
    changePage: function(pageNum, event) {
      event.preventDefault()
      this.$emit('change-page', pageNum)
    },
    nextPage: function(event) {
      if (this.isLastPageSelected) {
        event.preventDefault()
        return
      }
      this.changePage(this.selectedPageNum + 1, event)
    },
    prevPage: function(event) {
      if (this.isFirstPageSelected) {
        event.preventDefault()
        return
      }
      this.changePage(this.selectedPageNum - 1, event)
    },
    isActive: function(pageNum) {
      return pageNum === this.selectedPageNum
    },
    isEllipsis: function(pageNum) {
      return pageNum === '...'
    }
  },
  watch:
  {
    selfPageSize: function(newVal, oldVal) {
      if (+newVal !== +oldVal && oldVal !== null && newVal !== this.pageSize) {
        this.$emit('update:page-size', newVal)
        this.$emit('change-page', 1)
      }
    },
    pageSize: function(newVal) {
      this.selfPageSize = newVal
    }
  },
  mounted: function() {
    this.selfPageSize = this.pageSize
  }
}
</script>